export const TOPIC_PRACTICE_LOCAL_STORAGE_KEY = 'topic-practice';
